import { Flex } from '@mantine/core';

import { Text } from 'components';

interface ILabelValue {
  label: string;
  value: any;
}

const LabelValue = ({
  label,
  value,
}: ILabelValue) => {
  return (
    <Flex mr={'md'}>
      <Text c={'green'} fw={'bold'} mr={'sm'}>{label}</Text>
      <Text>{value}</Text>
    </Flex>
  )
}

export default LabelValue;